import { Button, TextField, useMediaQuery } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { useContext, useEffect, useState } from "react";
import MensagemSucesso from "../../../../components/MensagemSucesso";
import MensagemErro from "../../../../components/MensagemErro";
import { criarFiltro } from "../../../../services/api-relatorios.service";
import { ExportRelatorioContext } from "../../../../components/BotaoRelatorio/ExportRelatorioContext";
import CloseIcon from "@mui/icons-material/Close";

const SaveFilter = ({ idRelatorio, hasSchema }) => {
  //#region ------- UseStates
  const [nameFilter, setNameFilter] = useState();
  const [snackBar, setSnackBar] = useState({
    error: false,
    success: false,
    msg: "",
  });

  const initialStateSaveComponente = {
    open: false,
    label: "Salvar o Filtro",
    icon: <SaveIcon />,
  };

  const [saveComponent, setSaveComponent] = useState(
    initialStateSaveComponente
  );

  const responsivUI = useMediaQuery("(min-width: 770px)");
  const { empresas, valoresFiltros, colunas, setPenddingSave, penddingSave } =
    useContext(ExportRelatorioContext);

  useEffect(() => {
    if (saveComponent.open) {
      setPenddingSave({ ...penddingSave, pendding: true });
    } else {
      setPenddingSave({ pendding: false, helpertext: "", error: false });
    }
  }, [saveComponent.open]);

  //#region ------  Handles

  const handleSnackBar = (type, msg = "") => {
    switch (type) {
      case "error":
        setSnackBar({ success: false, error: true, msg });
        break;

      case "success":
        setSnackBar({ success: true, error: false, msg });
        break;

      case "close":
        setSnackBar({ error: false, success: false, msg: "" });
        break;
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;

    function formatString(input) {
      const cleanedInput = input.replace(/[^a-zA-Z0-9\s]/g, "");

      const titleCaseString = cleanedInput
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      return titleCaseString;
    }

    setNameFilter(formatString(value));

    if (value) {
      setSaveComponent({
        ...saveComponent,
        label: "Salvar",
        icon: <SaveIcon />,
      });
    } else {
      setSaveComponent({
        ...saveComponent,
        label: "Fechar",
        icon: <CloseIcon />,
      });
    }
  };

  const handleSubmit = async () => {
    let newSchemas = null;
    if (hasSchema && empresas.length > 0) {
      newSchemas = empresas.map((item) => {
        return `z_${item.id}`;
      });
    }

    const newFiltros =
      valoresFiltros.length > 0
        ? valoresFiltros.map((item) => {
            // Encontrar todos os parâmetros no script do filtro
            const parametros = item.script?.match(/\$P\{[^}]*\}/g) || [];

            // Gerar valores correspondentes para cada parâmetro (ajuste conforme necessário)
            const valores = parametros.map((param) => {
              const findFiltro = valoresFiltros
                .filter((item) => item.script.includes(param))
                .map((filtro) => {
                  return filtro.valor;
                });
              return findFiltro;
            });
            return {
              ...item,
              parametros, // Array de parâmetros
              valores: valores[0], // Array de valores correspondentes
            };
          })
        : null;

    const body = {
      //montar o body direito para envio
      nomeDoFiltro: nameFilter,
      detalhes: {
        idRelatorio: idRelatorio,
        colunas: colunas?.length > 0 ? colunas : null,
        filtros: newFiltros,
        schemas: newSchemas,
      },
    };

    try {
      const isObjectNotEmpty = (obj) => {
        if (obj.idRelatorio === 1 && !obj.colunas) return false;
        if (obj.idRelatorio !== 1 && !obj.filtros && !obj.schemas) return false;
        return true;
      };

      if (isObjectNotEmpty(body.detalhes)) {
        const response = await criarFiltro(body);

        handleSnackBar("success", response.mensagem);

        setSaveComponent({
          open: false,
          label: "Salvar o Filtro",
          icon: <SaveIcon />,
        });
        setNameFilter("");
      } else {
        handleSnackBar("error", "Existem campos não preenchidos!");
      }
    } catch (error) {
      handleSnackBar("error", error.response.data.mensagem);
    }
  };

  const handleSave = async () => {
    if (saveComponent.open && nameFilter) {
      await handleSubmit();
    } else {
      setSaveComponent({ open: true, label: "Fechar", icon: <CloseIcon /> });
      if (saveComponent.open && !nameFilter) {
        setSaveComponent({
          open: false,
          label: "Salvar o Filtro",
          icon: <SaveIcon />,
        });
      }
    }
  };
  //#endregion

  //#region ------- Styles
  const styleButton = {
    border: "1px solid #18316E",
    borderRadius: "4px",
    minWidth: "180px",
    color: "#18316E",
    "&:hover": {
      backgroundColor: "#d0daf5",
    },
  };

  const styleTextField = {
    transform: saveComponent.open ? `scaleX(1.0)` : `scaleX(0)`,
    transition: "all 0.7s ease-in-out",
    transformOrigin: "right",
  };

  const styledContainerSaveComponent = {
    display: "flex",
    flexDirection: responsivUI ? "row" : "column",
    marginBlock: "0.8rem",
    alignItems: penddingSave.helpertext ? "flex-start" : "center",
    gap: "1rem",
  };
  //#endregion

  return (
    <>
      <div style={styledContainerSaveComponent}>
        <TextField
          label="Nome do Filtro"
          fullWidth
          name="nomeDoFiltro"
          value={nameFilter}
          onChange={handleChange}
          size="small"
          error={penddingSave.error}
          helperText={penddingSave.helpertext}
          sx={styleTextField}
        />

        <Button
          startIcon={saveComponent.icon}
          size="medium"
          sx={styleButton}
          onClick={handleSave}
          fullWidth={responsivUI ? false : true}
        >
          {saveComponent.label}
        </Button>
      </div>

      <MensagemSucesso
        open={snackBar.success}
        handleClose={() => handleSnackBar("close")}
        msg={snackBar.msg}
      />

      <MensagemErro
        open={snackBar.error}
        handleClose={() => handleSnackBar("close")}
        msg={snackBar.msg}
      />
    </>
  );
};
export default SaveFilter;
